import React from "react";
import { Tabs, Tab } from "@jsq/ds/core";

export enum TabOptions {
  UNSYNCED = "unsynced",
  HISTORY = "history",
}

type Props = {
  unsyncedCount: number;
  activeTab: TabOptions;
  onClick: (option: React.SetStateAction<TabOptions>) => void;
};

const TransferTabs = (props: Props) => {
  return (
    <Tabs>
      <Tab
        active={props.activeTab === TabOptions.UNSYNCED}
        text="Transfers in queue"
        onClick={() => props.onClick(TabOptions.UNSYNCED)}
        counterBadgeProps={{
          count: props.unsyncedCount,
          variant: props.unsyncedCount > 0 ? "important" : "neutral",
        }}
      />
      <Tab
        active={props.activeTab === TabOptions.HISTORY}
        onClick={() => props.onClick(TabOptions.HISTORY)}
        text="Transfers history"
      />
    </Tabs>
  );
};

export default TransferTabs;
